export default __webpack_public_path__ + "images/07adbbd18b971ebab0c925746284c010-stomach_icon.png";